module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "tag-submit grupo-exportar"
  }, [(_vm.controlerBtnSubmit) ? _c('button', {
    staticClass: "btn btn-primary btn-exportar",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exportarSla()
      }
    }
  }, [_vm._v(" Imprimir ")]) : _c('button', {
    staticClass: "btn btn-primary btn-exportar",
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" aguarde...")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d31104d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sla/exportarSla/Index.vue
// module id = 994
// module chunks = 1